<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'
import { pageName } from '../../store/pageName'

type Language = {
	name: string
	url: string
	pcs?: string // only for the pcs domain
}

type Country = {
	app: boolean | string
	name: string
	url: string
	languages: { [key: string]: Language }
}

const countryListRaw = ref<{ [key: string]: Country }>({})

const filterCountriesWithPcs = (
	countries: { [key: string]: Country },
	pageName: string,
): { [key: string]: Country } => {
	const result: { [key: string]: Country } = {}

	for (const [countryCode, country] of Object.entries(countries)) {
		const { languages } = country
		const hasPcs = Object.values(languages).some(
			language => language.pcs === 'yes',
		)

		if (pageName === '') {
			// If pageName is empty, display all languages
			result[countryCode] = country
		} else if (hasPcs) {
			// If pageName is not empty and has pcs, only display languages with pcs
			result[countryCode] = country
		}
	}

	return result
}

// If the page is on the pcs domain, append '/shop' to the language URL
const createLanguageUrl = computed(() => {
	return (language: Language) => {
		return pageName.value === '' ? language.url : `${language.url}/shop`
	}
})

onMounted(() => {
	countryListRaw.value = window.BUYANDSHIP.settings.all_countries
})

const filteredCountries = computed(() =>
	filterCountriesWithPcs(countryListRaw.value, pageName.value),
)
</script>

<template>
	<ul class="bs-language-list">
		<template v-for="(country, iso) in filteredCountries" :key="iso">
			<template
				v-for="(language, code) in country.languages"
				:key="`${country.name}_${language.name}`"
			>
				<a class="bs-language-list__item" :href="createLanguageUrl(language)">
					<span :class="'icon-flag-' + iso + '-md'"></span>
					<span class="bs-language-list__item__name">
						{{ country.name }} - {{ language.name }}
					</span>
				</a>
			</template>
		</template>
	</ul>
</template>
